function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "172.565,49.028 178.036,85.911 175.903,107.137 173.682,106.671 175.903,123.356 174.331,129.563  175.624,139.949 173.215,141.795 163.393,139.017 161.166,140.687 162.464,147.822 173.493,168.58 170.437,172.288 175.253,183.783  156.164,200 154.403,192.861 144.117,187.302 137.998,177.109 139.022,176.457 137.256,173.679 135.311,174.606 124.189,167.192  122.153,155.881 123.727,150.786 114.46,148.285 113.81,146.155 110.757,146.892 86.656,113.899 85.824,103.43 83.133,103.892  74.605,84.334 75.07,76.646 67.193,56.353 69.976,48.75 69.602,45.506 55.979,39.482 55.794,34.476 50.231,31.416 45.413,32.343  44.767,34.013 29.657,22.707 27.063,23.819 21.964,17.329 23.081,10.846 30.774,0 34.011,4.171 118.628,45.318 "
});

var Svg26 = function Svg26(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SON",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg26, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/26.a7709c75.svg";
export { ForwardRef as ReactComponent };